import Phaser from 'phaser';
import './styles.css';
import { CharacterSelectScene } from './game/CharacterSelectScene';
import { VIEW_HEIGHT, VIEW_WIDTH } from './game/constants';
import { GameScene } from './game/GameScene';
import { MenuScene } from './game/MenuScene';
import { initializeTelegram } from './telegram';

const lifecycle = initializeTelegram();
const previewScreen = new URLSearchParams(window.location.search).get('screen');
const directGamePreview = previewScreen === 'gameplay'
  || previewScreen === 'levelup'
  || previewScreen === 'pause'
  || previewScreen === 'result';

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  width: VIEW_WIDTH,
  height: VIEW_HEIGHT,
  backgroundColor: '#0b0e0d',
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
    powerPreference: 'high-performance',
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  input: {
    activePointers: 3,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: VIEW_WIDTH,
    height: VIEW_HEIGHT,
  },
  scene: directGamePreview
    ? [GameScene, MenuScene, CharacterSelectScene]
    : previewScreen === 'characters'
      ? [CharacterSelectScene, MenuScene, GameScene]
      : [MenuScene, CharacterSelectScene, GameScene],
});

lifecycle.onDeactivated(() => game.events.emit('kuogam:pause'));
lifecycle.onActivated(() => game.events.emit('kuogam:resume'));

document.addEventListener('visibilitychange', () => {
  game.events.emit(document.hidden ? 'kuogam:pause' : 'kuogam:resume');
});
